<script setup lang="ts">
import type { EsProductFragment } from '#graphql-operations'

const { product } = defineProps<{
  product: EsProductFragment
}>()

const inStock = computed(() =>
  product.saleType !== 'OUTLET' && product.stockStatus && !product.stockBackorder,
)
const hasDeliveryTime = computed(() => {
  return product.stockBackorder && (product.deliveryTime ?? 0) > 0
})

const weeks = computed(() => Math.floor(product.deliveryTime! / 5))
</script>

<template>
  <slot
    :in-stock="inStock"
    :has-delivery-time="hasDeliveryTime"
    :weeks="weeks"
  >
    <span
      v-if="inStock"
      class="label-stock label--stock label--available"
    >
      {{ $t('Available from stock') }}
    </span>
    <span
      v-else-if="hasDeliveryTime"
      class="label-stock label--no-stock label--delayed"
    >
      {{ $t('Expected delivery time from: {weeks} weeks', { weeks }) }}
    </span>
  </slot>
</template>
